import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html'
})
export class MainContentComponent implements OnInit {

  constructor(private commonDataService: CommonDataService) { }

  ngOnInit(): void {
    this.hideLoader();
    this.commonDataService.showLoader.subscribe(data => {
      if (data) {
        this.showLoader();
      }
      else {
        this.hideLoader();
      }
    })
  }

  showLoader() {
    document.getElementById("loader-overlay").style.display = "block";
  }
  hideLoader() {
    document.getElementById("loader-overlay").style.display = "none";
  }
}
